import {
	getWarehouse,
	addWarehouse,
	editWarehouse,
	delWarehouse,
	getWarehouseManager,
	getDrpunit,
	addDrpunit,
	editDrpunit,
	delDrpunit,
	getWarehouseMaterial,
	getMaterial,
	saveWarehouseDetail,
	addWarehouseDetail,
	getWarehouseList,
	delIntoId,
	editSaveWarehouseDetail,
	editAddWarehouseDetail,
	saveOuthouseDetail,
	editSaveOuthouseDetail,
	addOuthouseDetail,
	editAddOuthouseDetail,
	getOuthouseList,
	delOutId,
	importMaterial,
	getDepotmanagedetail,
	getpicidetail,
	getCheckinventory,
	saveCheckinventory,
	commitCheckinventory,
	delCheckId,
	saveEditcheckinventory,
	commitEditcheckinventory,
	getCheckdifferanalyse,
	getCostanalysis,
	getInventroymaterial,
	getCheckinventorymaterial,
	getCheckinventorymateriallist,
	getMonthcaigoudetail,
	uploadRukuexcel,
	getKucunyujing,
	getGuoqiyujing,
	getImportrecord,
	getWarehouseData,
	setkucun
} from '@/api/stock'
// import { getToken } from '@/utils/auth'
const state = {}
const mutations = {}

const actions = {
	getWarehouse ({}, data) {
		return new Promise((resolve, reject) => {
			getWarehouse(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	addWarehouse ({}, data) {
		return new Promise((resolve, reject) => {
			addWarehouse(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	editWarehouse ({}, data) {
		return new Promise((resolve, reject) => {
			editWarehouse(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	delWarehouse ({}, data) {
		return new Promise((resolve, reject) => {
			delWarehouse(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getWarehouseManager ({}, data) {
		return new Promise((resolve, reject) => {
			getWarehouseManager(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getDrpunit ({}, data) {
		return new Promise((resolve, reject) => {
			getDrpunit(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	addDrpunit ({}, data) {
		return new Promise((resolve, reject) => {
			addDrpunit(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	editDrpunit ({}, data) {
		return new Promise((resolve, reject) => {
			editDrpunit(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	delDrpunit ({}, data) {
		return new Promise((resolve, reject) => {
			delDrpunit(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},

	getMaterial ({}, data) {
		return new Promise((resolve, reject) => {
			getMaterial(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getWarehouseMaterial ({}, data) {
		return new Promise((resolve, reject) => {
			getWarehouseMaterial(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	saveWarehouseDetail ({}, data) {
		return new Promise((resolve, reject) => {
			saveWarehouseDetail(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	addWarehouseDetail ({}, data) {
		return new Promise((resolve, reject) => {
			addWarehouseDetail(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getWarehouseList ({}, data) {
		return new Promise((resolve, reject) => {
			getWarehouseList(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	delIntoId ({}, data) {
		return new Promise((resolve, reject) => {
			delIntoId(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	editSaveWarehouseDetail ({}, data) {
		return new Promise((resolve, reject) => {
			editSaveWarehouseDetail(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	editAddWarehouseDetail ({}, data) {
		return new Promise((resolve, reject) => {
			editAddWarehouseDetail(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	saveOuthouseDetail ({}, data) {
		return new Promise((resolve, reject) => {
			saveOuthouseDetail(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	editSaveOuthouseDetail ({}, data) {
		return new Promise((resolve, reject) => {
			editSaveOuthouseDetail(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	addOuthouseDetail ({}, data) {
		return new Promise((resolve, reject) => {
			addOuthouseDetail(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	editAddOuthouseDetail ({}, data) {
		return new Promise((resolve, reject) => {
			editAddOuthouseDetail(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getOuthouseList ({}, data) {
		return new Promise((resolve, reject) => {
			getOuthouseList(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	delOutId ({}, data) {
		return new Promise((resolve, reject) => {
			delOutId(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	importMaterial ({}, data) {
		return new Promise((resolve, reject) => {
			importMaterial(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getDepotmanagedetail ({}, data) {
		return new Promise((resolve, reject) => {
			getDepotmanagedetail(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getpicidetail ({}, data) {
		return new Promise((resolve, reject) => {
			getpicidetail(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	setkucun ({}, data) {
		return new Promise((resolve, reject) => {
			setkucun(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getCheckinventory ({}, data) {
		return new Promise((resolve, reject) => {
			getCheckinventory(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	saveCheckinventory ({}, data) {
		return new Promise((resolve, reject) => {
			saveCheckinventory(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	commitCheckinventory ({}, data) {
		return new Promise((resolve, reject) => {
			commitCheckinventory(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	delCheckId ({}, data) {
		return new Promise((resolve, reject) => {
			delCheckId(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	saveEditcheckinventory ({}, data) {
		return new Promise((resolve, reject) => {
			saveEditcheckinventory(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	commitEditcheckinventory ({}, data) {
		return new Promise((resolve, reject) => {
			commitEditcheckinventory(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getCheckdifferanalyse ({}, data) {
		return new Promise((resolve, reject) => {
			getCheckdifferanalyse(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getCostanalysis ({}, data) {
		return new Promise((resolve, reject) => {
			getCostanalysis(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getInventroymaterial ({}, data) {
		return new Promise((resolve, reject) => {
			getInventroymaterial(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getCheckinventorymaterial ({}, data) {
		return new Promise((resolve, reject) => {
			getCheckinventorymaterial(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getCheckinventorymateriallist ({}, data) {
		return new Promise((resolve, reject) => {
			getCheckinventorymateriallist(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getMonthcaigoudetail ({}, data) {
		return new Promise((resolve, reject) => {
			getMonthcaigoudetail(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	uploadRukuexcel ({}, data) {
		return new Promise((resolve, reject) => {
			uploadRukuexcel(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getKucunyujing ({}, data) {
		return new Promise((resolve, reject) => {
			getKucunyujing(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getGuoqiyujing ({}, data) {
		return new Promise((resolve, reject) => {
			getGuoqiyujing(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getImportrecord ({}, data) {
		return new Promise((resolve, reject) => {
			getImportrecord(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getWarehouseData ({}, data) {
		return new Promise((resolve, reject) => {
			getWarehouseData(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
